// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateAgentMarketingProfileBasicInfo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfileBasicInfoUpdated"]);
}

var variablesConverter = {"updateAgentMarketingProfileBasicInfoInput":{"website":{"b":""}},"__root":{"input":{"r":"updateAgentMarketingProfileBasicInfoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateAgentMarketingProfileBasicInfo_AgentMarketingProfileBasicInfoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileBasicInfo":{"u":"response_updateAgentMarketingProfileBasicInfo"}}};

var wrapResponseConverterMap = {
  response_updateAgentMarketingProfileBasicInfo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateAgentMarketingProfileBasicInfo_AgentMarketingProfileBasicInfoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileBasicInfo":{"u":"response_updateAgentMarketingProfileBasicInfo"}}};

var responseConverterMap = {
  response_updateAgentMarketingProfileBasicInfo: unwrap_response_updateAgentMarketingProfileBasicInfo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileBasicInfoSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileBasicInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileBasicInfoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentMarketingProfileBasicInfoSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileBasicInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licenseNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "website",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "brokerage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileBasicInfoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce7a897adf54d502aae7c511bf3b849d",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileBasicInfoSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileBasicInfoSettingsMutation(\n  $input: UpdateAgentMarketingProfileBasicInfoInput!\n) {\n  updateAgentMarketingProfileBasicInfo(input: $input) {\n    __typename\n    ... on AgentMarketingProfileBasicInfoUpdated {\n      marketingProfile {\n        ...AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileBasicInfoSettings_form_agentMarketingProfile on AgentMarketingProfile {\n  firstName\n  lastName\n  licenseNumber\n  website\n  brokerage\n  publicUrl\n}\n"
  }
};
})());

var wrap_response_updateAgentMarketingProfileBasicInfo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileBasicInfo = unwrap_response_updateAgentMarketingProfileBasicInfo;
exports.wrap_response_updateAgentMarketingProfileBasicInfo = wrap_response_updateAgentMarketingProfileBasicInfo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
